import AnnouncementForm from 'components/AnnouncementForm';
import React from 'react';

const AnnouncementsCreate: React.FC = () => (
  <AnnouncementForm />
);

export default AnnouncementsCreate;
